import React from 'react';
import { Modal, Paper, Box, Typography, IconButton, Grid } from '@material-ui/core';
import { CloseOutlined as CloseIcon, TrendingUpOutlined as TrendingUpIcon } from '@material-ui/icons';
import { NamespaceGroup } from '../types/metrics.types';
import { MetricItem } from './MetricItem';
import { useMetricModalStyles } from '../styles/metric-modal.styles';

interface MetricModalProps {
  selectedPrimitive: NamespaceGroup | null;
  onClose: () => void;
}

export const MetricModal = React.memo<MetricModalProps>(({
  selectedPrimitive, 
  onClose 
}) => {
  const classes = useMetricModalStyles();
  
  if (!selectedPrimitive) return null;

  return (
    <Modal
      open={!!selectedPrimitive}
      onClose={onClose}
      className={classes.modal}
    >
      <Paper className={classes.paper}>
        {/* Header */}
        <Box className={classes.header}>
          <Typography variant="h5" className={classes.title}>
            {selectedPrimitive.primitiveName} Metrics
          </Typography>
          <IconButton onClick={onClose} data-testid="close-button">
            <CloseIcon />
          </IconButton>
        </Box>
        
        {/* Metrics Grid */}
        <Grid container spacing={2}>
          {selectedPrimitive.metrics.map((metric, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Paper elevation={1} className={classes.metricPaper}>
                <Box className={classes.metricContainer}>
                  <TrendingUpIcon className={classes.metricIcon} />
                  <Box>
                    <Typography variant="caption" color="textSecondary">
                      {metric.name}
                    </Typography>
                    <Typography variant="h6" className={classes.metricValue}>
                      {metric.value}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Modal>
  );
});

MetricModal.displayName = 'MetricModal';
